import React from 'react';
import { injectIntl } from 'react-intl';
import PropTypes from 'prop-types';
import AppConfig from '../../../appConfig';
import Mixpanel, { MIXPANEL_EVENTS, MIXPANEL_LOCATIONS } from '../../../helpers/Mixpanel';
import BusComponent from '../../BusComponent';

class NoDealsInListPage extends BusComponent {
    constructor(props, context) {
        super(props, context);
    }

    componentWillUnmount() {
        this.unbindGluBusEvents();
    }

    onLearnMore = () => {
        Mixpanel.emitUserEvent(MIXPANEL_EVENTS.LEARN_MORE_CLICK, {
            location: MIXPANEL_LOCATIONS.noDealsInList,
            url: AppConfig.constants.learnMoreDealsListLink,
            timestamp: new Date().toISOString(),
        });
        window.open(AppConfig.constants.learnMoreDealsListLink, '_blank');
    };

    render() {
        return (
            <div className="no-deals-page-container">
                <img
                    src={`${AppConfig.constants.assetsBaseURL}/svg/empty-list.svg`}
                    alt="Empty list image"
                />
                <div className="no-deals-page-content">
                    <h4>Nothing in this list yet</h4>
                    <div className="text-content">
                        <span className="body-1">
                            Drop a pin on the map and click <strong>Save</strong>
                            <i className="material-icons">add_location_alt</i> to save it to this
                            list.
                        </span>
                    </div>
                    <button onClick={this.onLearnMore}>
                        <h5>Learn more</h5>
                    </button>
                </div>
            </div>
        );
    }
}

NoDealsInListPage.propTypes = {
    intl: PropTypes.object.isRequired,
};

export default injectIntl(NoDealsInListPage);
